import request from '@/utils/request'


/**
 * 查询用户证书
 */
export function getCertificate() {
    return request({
        url: 'api/medal/certificate/current',
        method: 'get'
    })
}

/**
 * 保存用户证书
 */
export function saveCertificate(params) {
    return request({
        url: 'api/medal/certificate',
        method: 'post',
        data: params
    })
}

/**
 * 更新用户证书
 */
export function updateCertificate(params) {
    return request({
        url: 'api/medal/certificate',
        method: 'put',
        data: params
    })
}

/**
 * 删除用户证书
 */
export function deleteCertificate(id) {
    return request({
        url: `api/medal/certificate/${id}`,
        method: 'delete'
    })
}

/**
 * 查询用户勋章
 */
export function getUserMedal() {
    return request({
        url: 'api/medal/current',
        method: 'get'
    })
}